module.exports = __webpack_public_path__ + "static/a-xx-158-art-249e0a324ee0b08190785fd2c63df8b6.jpg";